import type { PERMISSIONS } from '@type/permissions';

export const getFirstCorrectPermission = (
    memberPermissions: { [key in PERMISSIONS]?: boolean },
    requiredPermissions: PERMISSIONS[]
) => requiredPermissions.find((requiredPermission) => memberPermissions[requiredPermission]);
